import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b616679"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminDomains" }
const _hoisted_2 = { id: "showdomains" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--baseline justify--start" }
const _hoisted_6 = { class: "md5 flex" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_12 = {
  class: "va-table--striped domainstable",
  style: {"width":"100%"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Domænetitel"),
    /*#__PURE__*/_createElementVNode("th", null, "Domænets FQDN"),
    /*#__PURE__*/_createElementVNode("th", null, "Handlinger")
  ])
], -1))
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Det er ikke på nuværende tidspunkt muligt selv at slette et domæne. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Hvis I forsat ønsker at slette domænet, så kontakt jeres IT-ansvarlige")
    ])
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_24 = { class: "editDomainModal" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Ændre domæne-oplysninger")
], -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "md8 flex domainModal" }
const _hoisted_28 = { class: "md4 flex domainModal" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_31 = { class: "tabHeight" }
const _hoisted_32 = { id: "newdomains" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "form"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "domainform-group" }
const _hoisted_37 = { class: "layout gutter--xl" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "flex md6" }
const _hoisted_40 = { class: "flex md6" }
const _hoisted_41 = { class: "row justify--center" }
const _hoisted_42 = { class: "flex" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Opret domænet")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_button_toggle = _resolveComponent("va-button-toggle")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger domæner', 'Opret nyt domæne'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Sorter efter"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button_toggle, {
                  size: "small",
                  rounded: false,
                  outline: "",
                  modelValue: _ctx.toggleIconsSortingValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toggleIconsSortingValue) = $event)),
                  options: [
                  { label: 'Domænetitel', value: 'domaintitle' },
                  { label: 'Domænets FQDN', value: 'domainfqdn' }]
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.domainSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.domainSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findDomain()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findDomain()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Filtrere efter status",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_select, {
                  class: "ml-4",
                  modelValue: _ctx.filterStatusStringValue,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
                  options: _ctx.filterStatusStringOptions,
                  bordered: "",
                  style: {"width":"75%"}
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domaenes, (domaene, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: domaene.id
                  }, [
                    _createElementVNode("td", {
                      id: 'domainstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(domaene.id), 9, _hoisted_14),
                    (domaene.domaene_titel === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          id: 'domainstable-row' + (index+1)
                        }, _toDisplayString('-'), 8, _hoisted_15))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          id: 'domainstable-row' + (index+1)
                        }, _toDisplayString(domaene.domaene_titel), 9, _hoisted_16)),
                    (domaene.domaene_url === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 2,
                          id: 'domainstable-row' + (index+1)
                        }, _toDisplayString('-'), 8, _hoisted_17))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 3,
                          id: 'domainstable-row' + (index+1)
                        }, _toDisplayString(domaene.domaene_url), 9, _hoisted_18)),
                    _createElementVNode("td", {
                      id: 'domainstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "editdomain",
                            onClick: ($event: any) => (_ctx.editDomain(domaene.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            icon: domaene.domaene_status ? 'check_box' : 'check_box_outline_blank',
                            color: domaene.domaene_status ? 'success' : 'rgb(255, 172, 10)',
                            class: "btn status-width",
                            name: "statuschangedomain",
                            onClick: ($event: any) => (_ctx.statusDomain(domaene.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(domaene.domaene_status ? 'Aktiv' : 'Inaktiv'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"]),
                          _createVNode(_component_va_button, {
                            color: "danger",
                            class: "btn",
                            name: "deletedomain",
                            onClick: ($event: any) => (_ctx.deleteDomainWarning(domaene.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_19)
                  ]))
                }), 128))
              ])
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteDomainWarningModal,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deleteDomainWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteDomainWarningModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editDomainModal,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editDomainModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateDomain() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editDomainModal = false), _ctx.cancelDomainEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.domainData.domainTitle,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.domainData.domainTitle) = $event)),
                    label: "Domænetitel",
                    placeholder: "Titel",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.domainData.domainURL,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.domainData.domainURL) = $event)),
                    label: "Domænets FQDN",
                    placeholder: "FQDN",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger domæner']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newdomainform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.domainData.domainTitle,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.domainData.domainTitle) = $event)),
                                    type: "text",
                                    label: "Domænetitel",
                                    rules: [(domainTitle) => _ctx.domainData.domainTitle.length > 1 || 'Der mangler en titel'],
                                    placeholder: "Titel",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.domainData.domainURL,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.domainData.domainURL) = $event)),
                                    type: "text",
                                    label: "Domænets FQDN",
                                    rules: [(domainURL) => _ctx.domainData.domainURL.length > 2 || 'Der mangler et navn'],
                                    placeholder: "FQDN",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createDomain()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_43
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret nyt domæne']
      ])
    ])
  ]))
}